"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TOOL TIP : STYLES --------------- ++++++++++ */


var _default = {
  '@global': {
    // tooltip (override library theme color with custom colors) set on global because this component is rendered on the documents body element
    '.tippy-tooltip': {
      backgroundColor: '#D0EAFD !important',
      color: '#0D5D99 !important',
      fontSize: (0, _index.pxToEm)(16),
      padding: (0, _index.replacePXinStringWithEM)('10px 15px'),
      '& .list': {
        textAlign: 'left',
        '& .listitem': {
          display: 'flex',
          marginBottom: (0, _index.pxToEm)(5),
          '& .text': {
            marginLeft: (0, _index.pxToEm)(7)
          }
        }
      },
      // custom styles for content housed within tip (use these classNames in JSX elements where we define content for tip if you want)
      '& .tip-content': {
        padding: (0, _index.replacePXinStringWithEM)('10px 0'),
        '& .tip': {
          '&-title': {
            fontSize: (0, _index.pxToEm)(18),
            fontWeight: 'bold',
            marginBottom: (0, _index.pxToEm)(10)
          },
          '&-desc': {
            marginBottom: (0, _index.pxToEm)(15),
            '& p, ul, ol': {
              marginBottom: (0, _index.pxToEm)(15)
            }
          },
          '&-link': {
            cursor: 'pointer',
            fontWeight: 'bold',
            textDecoration: 'underline'
          }
        }
      }
    },
    '.tippy-popper[x-placement^=top] [x-arrow]': {
      borderTopColor: '#D0EAFD !important'
    },
    '.tippy-popper[x-placement^=bottom] [x-arrow]': {
      borderBottomColor: '#D0EAFD !important'
    },
    '.tippy-popper[x-placement^=left] [x-arrow]': {
      borderLeftColor: '#D0EAFD !important'
    },
    '.tippy-popper[x-placement^=right] [x-arrow]': {
      borderRightColor: '#D0EAFD !important'
    }
  }
};
exports.default = _default;